import { UtilsString } from '@/utils/utils-string';
import { JwtService } from './JwtService';

export default class UserService {

    private userName = 'user';

    public hasuser() {
        return !UtilsString.IsNullOrWhiteSpace(this.getuser());
    }

    public setuser(user: string) {
        window.localStorage.setItem(this.userName, user);
    }

    public getuser() {
        return window.localStorage.getItem(this.userName);
    }

    public clearuser() {
        window.localStorage.removeItem(this.userName);
    }

    public IsAdmin() {
        return JwtService.jwtIsAdmin();
    }

}

export const medicalUserService = new UserService();